module.exports = __webpack_public_path__ + "img/yuyue_step1_gife.b78812f6.png";